<template>
  <div class="tourHotelSelectRoom_reserveInfo">
    <div
      class="tourHotelSelectRoom_reserve-hotelName tourHotelSelectRoom-pcOnly"
    >
      {{ name }}
      {{ service }}
      {{ typeName ? '(' + typeName + ')' : '' }}
    </div>
    <div v-if="!isTourFree || promotion" class="tourHotelSelectRoom_refundInfo">
      <div v-if="!isTourFree">
        <p v-if="refundable" class="ok">
          <i class="fs20 fa fa-check"></i>キャンセル料無料<br />
          <span> {{ cancelDate }}まで </span>
        </p>
        <p v-else class="dont"><i class="fs20 fa fa-ban"></i>返金不可</p>
      </div>
      <p v-if="promotion" class="mt10">
        {{ promotion }}
      </p>
    </div>

    <div class="tourHotelSelectRoom_reserve_hotelPriceWrapper">
      <div class="tourHotelSelectRoom_reserve_hotelPriceWrapperInner">
        <p class="tourHotelSelectRoom_reserve_hotelPriceText">
          {{ personCount }}名 {{ stayDay }}泊合計
        </p>
        <template v-if="isGoto">
          <div class="tourHotelSelectRoom_reserve_hotelPriceBlock">
            <div class="tourHotelSelectRoom_reserve_hotelPriceText1">
              <p class="tag">支払実額</p>
              <p class="price">{{ gotoAmount }}</p>
            </div>
          </div>
          <div
            class="tourHotelSelectRoom_reserve_hotelPriceBlock tourHotelSelectRoom_reserve_hotelPriceBlock2"
          >
            <div class="tourHotelSelectRoom_reserve_hotelPriceText1">
              <p class="tag">旅行代金</p>
              <p v-if="isTourFree" class="price">{{ totalDiffValue }}</p>
              <p v-else-if="discount" class="price">{{ discount }}</p>
              <p v-else class="price">{{ totalValue }}</p>
            </div>
            <div
              v-if="discount"
              class="tourHotelSelectRoom_reserve_hotelPriceText2"
            >
              {{ totalValue }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="tourHotelSelectRoom_reserve_hotelPriceBlock">
            <div class="tourHotelSelectRoom_reserve_hotelPriceText1">
              <p class="price">
                <span v-if="discount"> {{ discount }} </span>
                <span v-else-if="isTourFree">{{ totalDiffValue }} </span>
                <span v-else> {{ totalValue }} </span>
              </p>
            </div>
            <div
              v-if="discount"
              class="tourHotelSelectRoom_reserve_hotelPriceBlock tourHotelSelectRoom_reserve_hotelPriceBlock2"
            >
              <div class="tourHotelSelectRoom_reserve_hotelPriceText2">
                {{ totalValue }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="tourHotelSelectRoom_detailButtonWrap">
      <template v-if="isDummy">
        <button
          v-if="detailDescription && Object.keys(detailDescription).length > 0"
          type="button"
          class="tourHotelSelectRoom_detailButton"
          @click="showDetail = true"
        >
          部屋の詳細
        </button>
        <button
          type="button"
          class="tourHotelSelectRoom_reserve_nextButton"
          :disabled="true"
        >
          空室なし
        </button>
      </template>
      <template v-else>
        <button
          type="button"
          class="tourHotelSelectRoom_detailButton"
          @click="showDetail = true"
        >
          部屋の詳細
        </button>
        <button
          type="button"
          class="tourHotelSelectRoom_reserve_nextButton"
          @click.prevent="$emit('plan-selected')"
        >
          このプランを選択する
        </button>
      </template>
    </div>
    <plan-detail-modal
      :show="showDetail"
      :image="roomDetailImage"
      :detail-description="detailDescription"
      @close="showDetail = false"
    />
  </div>
</template>

<script>
import PlanDetailModal from './PlanDetailModal.vue'

export default {
  name: 'PlanInfo',
  components: {
    PlanDetailModal,
  },
  props: {
    cancelDate: {
      type: String,
      default: '',
    },
    discount: {
      type: String,
      default: '',
    },
    gotoAmount: {
      type: String,
      default: '',
    },
    isGoto: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    personCount: {
      type: Number,
      required: true,
    },
    refundable: {
      type: Boolean,
      default: false,
    },
    service: {
      type: String,
      default: '',
    },
    stayDay: {
      type: Number,
      required: true,
    },
    totalValue: {
      type: String,
      default: '',
    },
    totalDiffValue: {
      type: String,
      default: '',
    },
    typeName: {
      type: String,
      default: '',
    },
    detailDescription: {
      type: [Array, Object],
      default: () => [],
    },
    detailImages: {
      type: Array,
      default: () => [],
    },
    isTourFree: {
      type: Boolean,
      default: false,
    },
    isDummy: {
      type: Boolean,
      default: false,
    },
    promotion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDetail: false,
    }
  },
  computed: {
    roomDetailImage() {
      if (this.detailImages && this.detailImages.length > 0) {
        return this.detailImages[0].replace('http://', 'https://')
      }
      return ''
    },
  },
}
</script>
